// Textos da faixa de leads pendentes do gatilho "Lead Ads: formulário recebido" (#306).

export function pendingLeadsLabel(total) {
  if (!total) return ''
  return total === 1
    ? '1 lead de formulário aguarda esta automação.'
    : `${total} leads de formulário aguardam esta automação.`
}

export function reprocessResultLabel(started) {
  if (!started) return 'Nenhum lead novo para processar.'
  return started === 1 ? '1 lead enviado para a automação.' : `${started} leads enviados para a automação.`
}
